import moment from 'moment';
import React from 'react';
import QRCode from "react-qr-code";
import { _endPoints, linkLogosResort } from '../../Helper/links';
import { RESORT_LOGO_PATH, RESORT_WEBSITE } from '../../Helper/user';
import apple_stor from '../../public/images/apple_stor.svg';
import google_play from '../../public/images/google_play.png';
import logo from '../../public/images/logo.png';

function HeaderInvoice(props) {
    return (
        <>
            <div className="row">
                <div className="col-3">
                    <div className="col-12 text-right" style={{ paddingTop: "50px" }}>
                        <div className="clf" >
                            <dl className="row pull-right" >
                                <dt className="col-sm-12">{moment(new Date()).format("YYYY-MM-DD")}</dt>
                                {/* <dd className="col-sm-12" style={{paddingRight:"15px",margin:"0"}}>طرابلس - غرور</dd> */}
                                <div style={{ height: "auto", marginTop: "2px", paddingRight: "15px", marginRight: "10px", maxWidth: 70, width: "100%" }}>
                                    {
                                        !RESORT_WEBSITE ?
                                            <QRCode
                                                size={200}
                                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                value={"https://" + RESORT_WEBSITE}
                                                viewBox={`0 0 256 256`}
                                            />
                                            :
                                            <QRCode
                                                size={200}
                                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                value={"https://yoursummer.ly"}
                                                viewBox={`0 0 256 256`}
                                            />
                                    }

                                </div>
                            </dl>

                        </div>
                    </div>
                </div>

                <div className="col-6">
                    <center>
                        <div className="invoice-logo">
                            <img src={_endPoints.resorts.images + RESORT_LOGO_PATH} height="150px" width="auto" alt='logo' />
                        </div>
                        {props?.title ?
                            <h4>{props.title}</h4>
                            :
                            <></>
                        }
                    </center>
                </div>

                <div className="col-3">
                    <center>
                        <div className="invoice-logo">
                            <img src={logo} height="100px" width="100px" alt='logo_ys' />
                            <br></br>
                            <img src={apple_stor} height="26px" alt='logo_apple_stor' style={{ marginTop: "5px" }} />
                            <br></br>
                            <img src={google_play} height="35px" alt='logo_google_play' />
                        </div>
                    </center>
                </div>
            </div>
            <hr />
        </>
    )
}

export default HeaderInvoice